import { render } from "./FilesListItem.vue?vue&type=template&id=5c47c9ee&scoped=true"
import script from "./FilesListItem.vue?vue&type=script&lang=js"
export * from "./FilesListItem.vue?vue&type=script&lang=js"

import "./FilesListItem.vue?vue&type=style&index=0&id=5c47c9ee&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c47c9ee"]])

export default __exports__